//export const direccion = 'http://localhost:8080/api/';
//export const direccion = 'https://calidad.gruposfr.com/api/';
export const direccion = 'https://test.gruposfr.com/api/';
